// extracted by mini-css-extract-plugin
export default {"modalBody":"CancelAutoPayForCreditsButton_modalBody__fzurq"};